import React from 'react';
import { times } from 'lodash';
import RQLFeedItem from './rql_feed_item';
import { MixedFeedRow } from '@reverbdotcom/commons/src/gql/graphql';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import { RCListingGrid } from '@reverbdotcom/cadence/components';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { isNonUSUser } from '@reverbdotcom/commons/src/user_context_helpers';

interface IProps {
  expectedCount: number;
  entries: MixedFeedRow.Fragment[];
  loading: boolean;
  cta?: JSX.Element;
  title?: string;
}

export default function FeedRow(props: IProps) {
  const user = useUser();
  const showFlags = isNonUSUser(user);

  return (
    <OverflowingRow
      collectionCount={props.entries.length}
      action={props.cta}
      title={props.title}
    >
      <RCListingGrid
        singleRow
        loading={props.loading}
      >
        {props.loading && props.entries.length === 0 ? (
          renderGridPlaceholders(props.expectedCount)
        ) : (
          props.entries.map((entry, idx) => (
            <RCListingGrid.Item
              key={entry.id}
            >
              <RQLFeedItem
                key={`${entry.__typename}-${entry.id}-${idx}`}
                entry={entry}
                position={idx}
                hideRemoveButton
                showFlags={showFlags}
              />
            </RCListingGrid.Item>
          ))
        )}
      </RCListingGrid>
    </OverflowingRow>
  );
}

function renderGridPlaceholders(count) {
  return times(count, index => (
    <RCListingGrid.Item
      key={index}
    >
      <RQLFeedItem />
    </RCListingGrid.Item>
  ));
}
